import { render, staticRenderFns } from "./TaskNotes.vue?vue&type=template&id=45ec7eca&"
import script from "./TaskNotes.vue?vue&type=script&lang=js&"
export * from "./TaskNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports